module.exports = __webpack_public_path__ + "img/cptgb-2-en.5e82584f.png";